<template>
  <div class="wrapper">
    <populate-form
      formTitle="劃位紀錄管理"
      fkey="rhm01"
      ref="filterStoreForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      :validatePrompt="false"
      :parentVue="this"
      @customValueChanged="filterChanged"
    ></populate-form>
    <div v-show="filterData.view_type==='his'">
      <b-table
        :items="reservation_histories"
        :fields="fields_his"
        stacked="sm"
      >
        <template v-slot:cell(reserve_type)="row">
          <!--外部分類名稱或票券課程名稱-->
          {{row.item.reserve_type==='s99_ticket'?row.item.ticket_project_name:row.item.ext_src_type_name}}
        </template>
        <template v-slot:cell(reserve_time)="row">
          <!--把劃位起訖時間把秒截掉黏在一起顯示-->
          {{row.item.reserve_start_time.substr(0,16)+'~'+row.item.reserve_end_time.substr(11,5)}}
        </template>
        <template v-slot:cell(reserve_info)="row">
          <!--s99票券顯示劃位消費者名字,自訂劃位顯示店家自己key的備註-->
          {{row.item.reserve_type==='s99_ticket'?row.item.reserve_user_name:row.item.reserve_remark}}
        </template>
        <template v-slot:cell(status)="row">
          <!--已履約/已過期/已取消-->
          {{textMap.close_status[row.item.close_status]}}
          {{row.item.close_status==='cancelled'?('('+textMap.cancel_status[row.item.cancel_status]+')'):''}}
          {{row.item.close_status==='expired'?('('+textMap.expire_type[row.item.expired_type]+')'):''}}
        </template>
        <template v-slot:cell(actions)="row">
          <b-button v-if="row.item.close_status==='expired'&&row.item.reserve_type==='s99_ticket'&&row.item.expired_type==='user_bird_store'" @click="showConfirmNotBird(row.item)">幫平反用戶爽約</b-button>
        </template>
      </b-table>
    </div>
    <div v-show="filterData.view_type==='new'">
      <b-table
        :items="reservations"
        :fields="fields_active"
        stacked="sm"
      >
        <template v-slot:cell(reserve_type)="row">
          <!--外部分類名稱或票券課程名稱-->
          {{(row.item.reserve_type==='s99_ticket'||row.item.reserve_type==='line_coupon_ticket')?row.item.ticket_project_name:row.item.ext_src_type_name}}
        </template>
        <template v-slot:cell(reserve_target_time)="row">
          <!--把劃位起訖時間把秒截掉黏在一起顯示-->
          {{row.item.reserve_start_time.substr(0,16)+'~'+row.item.reserve_end_time.substr(11,5)}}
        </template>
        <template v-slot:cell(reserve_info)="row">
          <!--s99票券顯示劃位消費者名字,自訂劃位顯示店家自己key的備註-->
          {{(row.item.reserve_type==='s99_ticket'||row.item.reserve_type==='line_coupon_ticket')?row.item.reserve_user_name:row.item.reserve_remark}}
        </template>
        <template v-slot:cell(actions)="row">
          <b-button class="mr-1" v-if="!row.item.negotiation_cancel_id" @click="showConfirmCancel(row.item)">取消劃位</b-button>
          <b-button class="mr-1" v-if="!row.item.negotiation_cancel_id" @click="goToSee(row.item)">看一看</b-button>
          <b-button class="mr-1" v-if="row.item.negotiation_cancel_id&&row.item.canceling_from==='store'" @click="cancelCancel(row.item)">抽回取消劃位</b-button>
        </template>
      </b-table>
    </div>
    <b-modal
      id="cancelConfirmModal"
      ref="cancelConfirmModal"
      v-model="modalConfirmShow" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <span v-show="alertCancelShow" style="color:red;" >取消原因不可空白</span>
      <b-form-textarea
        v-model="cancelRemark"
        placeholder="輸入取消劃位通知說明"
        rows="3"
      ></b-form-textarea>
      <b-button class="mt-1" @click="modalConfirmShow=false">取消</b-button>
      <b-button class="mt-1 ml-3" @click="cancelReservation">確認</b-button>
    </b-modal>
    <b-modal
      id="downloadModal"
      ref="downloadModal"
      v-model="modalDownloadShow" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="下載劃位資料"
        fkey="dl01"
        ref="downloadForm"
        populateOptionVar="downloadOptions"
        formDataObjVar="downloadData"
        :parentVue="this"
      ></populate-form>
      <!--<span v-show="alertDownloadShow" style="color:red;" >日期必須填寫正確完整</span>
      <date-picker class="col-5" placeholder="下載起始日" v-model="download_from_date" :config="{'format':'YYYY-MM-DD','useCurrent':false}"></date-picker>
      <date-picker class="col-5" placeholder="下載結束日" v-model="download_to_date" :config="{'format':'YYYY-MM-DD','useCurrent':false}"></date-picker>
      <b-button class="mt-1" @click="modalDownloadShow=false">取消</b-button>
      <b-button class="mt-1 ml-3" @click="downloadXls">確認</b-button>-->
    </b-modal>
    <beautiful-chat
      ref="bchatw"
      :participants="participants"
      :titleImageUrl="titleImageUrl"
      :onMessageWasSent="onMessageWasSent"
      :messageList="messageList"
      :newMessagesCount="newMessagesCount"
      :isOpen="isChatOpen"
      :close="closeChat"
      :icons="icons"
      :open="openChat"
      :showEmoji="true"
      :showFile="false"
      :showTypingIndicator="showTypingIndicator"
      :colors="colors"
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :messageStyling="messageStyling"
      placeholder="請輸入交談留言"
      :title="chatTitle"
      @scrollToTop="handleScrollToTop"
      @onType="handleOnType"
      @edit="editMessage"
      @chatTargetEntered="chatTargetEntered" />
  </div>
</template>

<script>

import saveAs from 'file-saver'
import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png'
import OpenIcon from 'vue-beautiful-chat/src/assets/logo-no-bg.svg'
import FileIcon from 'vue-beautiful-chat/src/assets/file.svg'
import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg'

export default {
  name: 'StoreReservationList',
  components: {
    
  },
  data: function () {
    return {
       icons:{
        open:{
          img: OpenIcon,
          name: 'default',
        },
        close:{
          img: CloseIcon,
          name: 'default',
        },
        file:{
          img: FileIcon,
          name: 'default',
        },
        closeSvg:{
          img: CloseIconSvg,
          name: 'default',
        },
      },
      participants: [
        {
          id: 'user1',
          name: 'Mario',
          imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4',
          newMsgCount:2
        },
        {
          id: 'user2',
          name: 'Spagegetti',
          imageUrl: null,
          newMsgCount:0
        },
        {
          id: 'user3',
          name: '胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖胖丁',
          imageUrl: null,
          newMsgCount:1
        },
      ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      chatTitle:"哈哈店的對話",
      titleImageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png',
      messageList: [
          { type: 'text', author: `me`, data: { text: `Say yes!` }, sendtime:'2019/9/5 11:00:05' },
          { type: 'text', author: `user1`, data: { text: `No.` }, sendtime:'2019/9/10 11:00:05' },
          { type: 'text', author: `user1`, data: { text: `Balabababa~~~ I'am love it!` }, sendtime:'2019/9/10 11:00:05' },
          { type: 'text', author: `user1`, data: { text: `這樣是絕對不可以的` }, sendtime:'2019/9/10 12:00:05' },
      ], // the list of the messages to show, can be paginated and adjusted dynamically
      // key是target user id, value是messageList陣列
      // 進入一個對象的聊天時要先呼叫api撈一些最近對話歷史紀錄,之後才是不斷pull新訊息往下捲,往上捲到底抓較舊的最近下一批對話資料
      // 快速切換對話對象時不立即重撈api(除非有未讀新訊息),定期pull只撈此店家此頻道最新被留言訊息與各頻道的未讀新訊息則數
      cachedMessageList:{

      },
      newMessagesCount: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        launcher: {
          bg: '#4e8cff'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true ,
      modalDownloadShow:false,
      /*alertDownloadShow:false,
      download_from_date:'',
      download_to_date:'',*/
      downloadData:{},
      downloadOptions:[
        {
          componentType:'span',
          col:12,
          placeholder:'這裡可以下載劃位紀錄,包括自訂外部保留類型的數據,請放心將小本本數據維護於此'
        },
        {
          componentType:'date-picker',
          akey:'from_date',
          col:6,
          placeholder:'下載起始日'
        },
        {
          componentType:'date-picker',
          akey:'to_date',
          col:6,
          placeholder:'下載截止日'
        },
        {
          componentType:'btn-group',
          col:12,
          buttons:[
            {
              col:1
            },
            {
              col:4,
              placeholder:'取消',
              execCallback:()=>{this.modalDownloadShow=false}
            },
            {
              col:1
            },
            {
              col:4,
              placeholder:'確認下載',
              execCallback:this.downloadXls
            }
          ]
        }
      ],
      alertCancelShow:false,
      modalConfirmShow:false,
      reservation_histories:[],
      reservations:[],
      cancelData: {},
      cancelRemark:"",
      fields_his:[
        {
          key:'reserve_type',
          label:'類型',//外部或s99_ticket兩種,用template欄位顯示(外)自訂類型或課程名稱
          thStyle: {width:'20vw'}
        },
        {
          key:'reserve_time',
          label:"劃位時間",//也用template欄位把起訖時間組成一個字串顯示
        },
        {
          key:'reserve_time',
          label:'劃位於'
        },
        {
          key:'reserve_info',
          label:'劃位資訊',//s99_ticket是會員姓名,外部劃位則是店家劃位備註欄位
        },
        {
          key:'status',
          label:'狀態',//狀態用close_status翻譯成template欄位顯示
        },
        {
          key:'actions',
          label:'操作'
        }
      ],
      fields_active:[
        {
          key:'reserve_type',
          label:'類型',//外部或s99_ticket兩種,用template欄位顯示(外)自訂類型或課程名稱
          thStyle: {width:'20vw'}
        },
        {
          key:'reserve_target_time',
          label:"劃位時間",//也用template欄位把起訖時間組成一個字串顯示
        },
        {
          key:'reserve_time',
          label:'劃位於'
        },
        {
          key:'reserve_info',
          label:'劃位資訊',//s99_ticket是會員姓名,外部劃位則是店家劃位備註欄位
        },
        {
          key:'reserve_time',
          label:'提出時間',
        },
        {
          key:'actions',
          label:'操作'
        }
      ],
      filterData:{},
      filterOptions:[
        {
          componentType:'b-form-radio-group',
          akey:'view_type',
          col:3,
          defaultValue:'his',
          dataOptions:[{text:'過期劃位紀錄',value:'his'},{text:'生效中劃位',value:'new'}]
        },
        {
          componentType:'date-picker',
          akey:'filter_date_s',
          col:2,
          placeholder:'篩選劃位日期-起',
        },
        {
          componentType:'date-picker',
          akey:'filter_date_e',
          col:2,
          placeholder:'篩選劃位日期-迄',
        },
        {
          componentType:'text',
          akey:'keyword',
          col:2,
          placeholder:'篩選劃位者姓名或劃位備註',
          execCallback:this.getData
        },
        {
          componentType:'b-button',
          col:3,
          placeholder:'我愛小本本',
          execCallback:this.showSownload
        }

      ],
      textMap:{
        close_status:{
          'expired':'已過期',
          'executed':'已履約',
          'cancelled':'已取消',
          'cancelled_after_excuted':'被後台手動取消'
        },
        expire_type:{
          'user_bird_store':'用戶爽約',
          'private_reserve_expire':'自訂劃位',
          'cancel_deal':'事後合意取消',
          'support_confirm_store_bird_user':'客服確認店家爽約',
          '':'未定義'
        },
        cancel_status:{
          'in_harmony':'合意取消',
          'in_peace':'一般爽約',
          'in_trouble':'嚴重爽約'
        }
      }
    }
  },
  methods: {
    sendMessage (text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
        this.onMessageWasSent({ author: 'support', type: 'text', data: { text } })
      }
    },
    onMessageWasSent (message) {
      console.log(message)
      let d = new Date()
      message.sendtime = d.toLocaleString('zh-TW',{hour12:false})
      if (Math.random() > 0.5) {
        message.suggestions = ['好','不好','不知道']
      }
      // called when the user sends a message
      // 吃得到 author type data,格式為 {"author":"me","type":"text","data":{"text":"WSAWE"}}的物件
      // 所以在這裡呼叫api送出新訊息即可,成功才執行下面的加入messageList
      this.messageList = [ ...this.messageList, message ]
    },
    openChat () {
      // called when the user clicks on the fab button to open the chat
      // 此時才即時需要pull訊息內容.
      // 如果已經有打開過初始化訊息陣列了,則只需要pull新的append,否則就初始撈取訊息到messageList
      // 如對應此組件的設計一打開就全部改已讀,那就同時要呼叫api把未讀全改已讀
      // 所以比較複雜一些,初始歷史對話訊息是否已讀取與是否有新訊息數字要一起判斷決定怎麼呼叫api
      this.isChatOpen = true
      this.$bus.hideMobileNavi = true
      this.newMessagesCount = 0
    },
    closeChat () {
      // called when the user clicks on the botton to close the chat
      // 關閉對話視窗時,則減低pull頻率且進入只更新新增對話數模式(不撈取與已讀新訊息,只反覆更新新訊息數字)
      this.$bus.hideMobileNavi = false
      this.isChatOpen = false
    },
    handleScrollToTop () {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
      console.log('handleScrollToTop')
  	},
    handleOnType () {
      console.log('Emit typing event')
    },
    editMessage(message){
      const m = this.messageList.find(m=>m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    },
    switchChatList(show_list) {
      this.$refs.bchatw.switchUserList(show_list)
    },
    chatTargetEntered(chat_user) {
      console.log(chat_user)
      // 有cache就讀cache, 沒cache就call api
      // cache晚點補
      let Param = {
        module:'store_chat',
        method:'getStoreMsg',
        store_id:this.$bus.session.merchant_store_id,
        user_id:chat_user.id,
        before_send_time:''
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('api讀取失敗：'+data.msg)
          return
        }
        vm.messageList = vm.parseMsgs(data.data.msgs, chat_user)
      },this)
    },
    parseMsgs(msgs, chat_user) {
      let parsed = []
      for (let i=0;i<msgs.length;i++) {
        parsed.push({
          type:'text',
          author:msgs[i].push_by==='store'?'me':chat_user.id,
          data:{
            text:msgs[i].message
          },
          sendtime:msgs[i].send_time
        })
      }
      return parsed
    },
    loadChatParticipants(getall=false) {
      let Param = {
        module:'store_chat',
        method:'getStoreChatParticipants',
        store_id:this.$bus.session.merchant_store_id,
        getall:getall?'1':'0'
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('api讀取失敗：'+data.msg)
          return
        }
        vm.newMessagesCount = 0
        //處理聊天呼叫的話主機會更忙,計算就移到前端
        for (let i=0;i<data.data.length;i++) {
          vm.newMessagesCount += data.data[i].newmsgcount
        }
        vm.participants = data.data
      },this)
    },
    downloadXls() {
      if (!this.downloadData.from_date||!this.downloadData.to_date||this.downloadData.from_date>this.downloadData.to_date) {
        this.$refs.downloadForm.triggerAlert('日期參數錯誤')
        return
      } 
      let Param = {
        module:'store',
        method:'getRvDownload',
        from_date:this.downloadData.from_date,
        to_date:this.downloadData.to_date
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('api讀取失敗：'+data.msg)
          return
        }
        saveAs(vm.getBlobFromBase64(data.data.xlsx),data.data.file_name)
        setTimeout(() => {
          vm.modalDownloadShow = false
        }, 1000);
      },this)
    },
    showSownload() {
      this.modalDownloadShow = true
    },
    goToSee(item) {
      let go_param = {}
      go_param.reservation_id = item.id
      go_param.data = item
      go_param.data.mwct_id = 0
      this.$bus.linkCallStack = [
        {landingComponent:this.$options._componentTag,params:{}},
        {landingComponent:'StoreRcManage',params:go_param}
      ]
      this.$bus.landingComponent = "StoreRcManage"
    },
    cancelCancel(item) {
      this.$bus.fnShowConfirm("是否確認抽回取消劃位的通知並保留此劃位有效？", ()=>{
        let Param = {
          module:'store',
          method:'cancelReservationCancellationByStore',
          negotiation_cancel_id:item.negotiation_cancel_id
        }
        this.$bus.apiCall(Param, function(data, vm) {
          if (data.ok == 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo("已通知取消劃位")
          setTimeout(() => {
            vm.$bus.fnClosePopup()            
          }, 1500);
          vm.getData()
        }, this)
      })
    },
    cancelReservation() {
      //檢查必填留言
      if (!this.cancelRemark) {
        this.alertCancelShow = true
        setTimeout(() => {
          this.alertCancelShow = false
        }, 2000);
        return
      }
      //call api通知用戶要取消劃位,待用戶回覆(是否接受),或隔天自動更新為已取消(一直沒更新的話是輕度爽約)
      let Param = {
        module:'store',
        method:'notifyReservationCancelByStore',
        reservation_result_id:this.cancelData.id,
        remark:this.cancelRemark
      }
      this.$bus.apiCall(Param, function(data, vm) {
        if (data.ok == 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        vm.$bus.fnShowInfo("已通知取消劃位")
        vm.modalConfirmShow = false
        vm.getData()
      }, this)
    },
    filterChanged(upd) {
      if (upd.key === 'view_type') {
        if (upd.val) {
          this.getData()
        }
        else {
          this.reservation_histories = []
          this.reservations = []
        }
      }
      else if (['filter_date_s','filter_date_e'].includes(upd.key) && this.filterData.SelectedStoreItem) {
        this.getData()
      }
    },
    showConfirmCancel(item) {
      this.cancelData = this.CpObj(item)
      this.cancelRemark = ""
      this.modalConfirmShow = true
    },
    showConfirmNotBird(item) {
      //可以填原因但就不能用fnShowConfirm了,之後需要再改成popup填取消原因
      this.$bus.fnShowConfirm("是否確認更新為店家對用戶爽約?", ()=>{
        let Param = {
          module:'work_site',
          method:'confirmAbsence',
          reservation_id:item.store_reservation_result_id,
          treat_as_normal_cancel:1,
          cancel_remark:''
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              vm.$bus.fnClosePopup()
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
            }
            vm.getHisData()
            vm.$bus.fnClosePopup()
            vm.$bus.fnShowInfo("更新完成")
        },this)
      })
    },
    getData() {
      if (this.filterData.view_type === 'his') {
        this.getHisData()
      }
      else {
        this.getActiveData()
      }
    },
    getHisData() {
      let Param = {
        module:'store',
        method:'getStoreReservationHistoryList',
        store_id:this.$bus.session.merchant_store_id,
        keyword:this.filterData.keyword,
        filter_date_s:this.filterData.filter_date_s?this.filterData.filter_date_s:'',
        filter_date_e:this.filterData.filter_date_e?this.filterData.filter_date_e:'',
        page_number:1,
        items_per_page:500,
        include_normal_cancelled:0,
      }
      this.$bus.apiCall(Param, function(data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        vm.reservation_histories = data.data
      }, this)
    },
    getActiveData() {
      let Param = {
        module:'store',
        method:'getStoreReservationList',
        keyword:this.filterData.keyword,
        filter_date_s:this.filterData.filter_date_s?this.filterData.filter_date_s:'',
        filter_date_e:this.filterData.filter_date_e?this.filterData.filter_date_e:'',
        page_number:1,
        items_per_page:500,
        include_normal_cancelled:0,
      }
      this.$bus.apiCall(Param, function(data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        vm.reservations = data.data
      }, this)
    },
    loadStoreByKeyword (keyword) {
      if (!keyword) {
        // 有填至少一個關鍵字才回傳選項
        this.Stores = []
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'getStoreAutoComplete',
        'keyword':keyword,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.Stores = data.data.matched_store_list
      },this)
    },
    /*getStatusText(item) {
      let status_m = ""
      let status_d = ""
      switch (item.close_status) {
        case 'executed':
          status_m = "已履約"
          break
        case 'expired':
          status_m = '已過期'
          break
        case 'cancelled':
          status_m = '已取消'
          break
      }
      if (status_m === '已過期') {

      }
      else if (status_m === '已取消') {

      }
      
    },*/
  },
  computed:{
    
  },
  created () {
    
  },
  mounted () {
    // 未初始化時預設值會是undefined,需注意呼叫api的參數處理
    this.$refs.filterStoreForm.initDefault()
    setTimeout(() => {
      this.loadChatParticipants()
      this.switchChatList(true)
    }, 500);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<!-- override掉外掛聊天UI組件的style...雖然已經改掉很多了但css還是優先用override方式不要全部改掉 -->
<style>
.wrapper .sc-launcher {
  width: 45px!important;
  height: 45px!important;
  right: 18px!important;
  bottom: 50px!important;
}

.wrapper .sc-launcher:before {
  width: 45px!important;
  height: 45px!important;
}

.wrapper .sc-launcher .sc-open-icon,
.wrapper .sc-launcher .sc-closed-icon {
  width: 45px!important;
  height: 45px!important;
  right: 18px!important;
  bottom: 50px!important;
}
.wrapper .sc-launcher .sc-open-icon {
  padding:12px!important;
}
.wrapper .sc-launcher .sc-closed-icon {
  width: 45px!important;
  height: 45px!important;
}
.wrapper .sc-message-time-me {
  font-size: xx-small;
  position: relative;
  top:50%;
}
.wrapper .sc-message-time-other {
  margin-left:-40px;
  font-size: xx-small;
  position: relative;
  top:50%;
}
.wrapper .sc-message {
  position:relative;
}
</style>

